var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLessThanTwoStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.987793L14.6968 9.28788H23.4241L16.3636 14.4176L19.0605 22.7177L12 17.588L4.9395 22.7177L7.63636 14.4176L0.575885 9.28788H9.30311L12 0.987793Z",
    fill: "#88087B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLessThanTwoStars);
export default __webpack_public_path__ + "static/media/active-less-than-two-stars.bd3a9f3f324e0fcde10cb8c720620d93.svg";
export { ForwardRef as ReactComponent };